import styled from 'styled-components';

export const BaseValueHolder = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background: linear-gradient(270deg, rgba(243, 26, 80, 0.56) 0%, rgba(222, 122, 70, 0.56) 51.49%);
`;

export const BaseValueButton = styled.div`
  height: 100%;
  width: 1.75rem;
  background: ${({ theme }) => theme.buttonLight};
`;

export const BaseValue = styled.div`
  width: calc(${({ $width }) => $width} - 1.75rem);
  height: 100%;
  transition: linear 0.2s;
  background: linear-gradient(270deg, #3B68FB 0%, #01C2FF 58%, #FFFFFF 98.5%);
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.buttonLight};
`;

export const CritValueHolder = styled.div`
  background: linear-gradient(90deg, rgba(11, 19, 103, 0.56) 0%, rgba(0, 0, 0, 0.56) 51.49%);
  border-left: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.baseViolet};
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const SpeedValueHolder = styled.div`
  background: linear-gradient(90deg, rgba(11, 19, 103, 0.56) 0%, rgba(0, 0, 0, 0.56) 51.49%);
  border-left: solid ${({ theme }) => theme.frameWidth} rgba(253, 173, 50, 1);
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const SpeedIndicator = styled.div`
  width: 20%;
  height: 100%;
  background: linear-gradient(270deg, #F31A50 0%, #DE7A46 51%);
  border: solid ${({ theme }) => theme.frameWidth} rgba(253, 173, 50, 1);
  animation: blink 0.5s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards; 
  border-left: none;
`;

export const CritIndicator = styled.div`
  width: 20%;
  height: 100%;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.baseViolet};
  animation: blink 0.5s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards; 
  border-left: none;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`; 

export const StyledBroadsiderStats = styled.div`
  padding: 0.75rem;
  width: 18rem;
  display: flex;
  flex-direction: column;
  gap: 1px;
  transform: scale(var(--app-scale));
  transform-origin: 0 100%;
`;

export const BroadsiderStat = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme, $decreased }) => $decreased ? theme.baseRed : theme.buttonDark};
  align-items: center;
  justify-content: start;
  animation: ${({ $decreased }) => $decreased ? 'pulsate 1.5s infinite' : 'none'};
`;

export const DecreasedStat = styled.div`
  height: 100%;
  background: repeating-linear-gradient(
    135deg,
    ${({ theme }) => theme.baseRed},
    ${({ theme }) => theme.baseRed} 5px,
    ${({ theme }) => theme.background} 5px,
    ${({ theme }) => theme.background} 10px
  );
`;

export const BroadsiderStatIconHolder = styled.div`
  height: 1.75rem;
  width: 2rem;
  border-right: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.buttonDark};

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`;

export const BroadsiderStatValueHolder = styled.div`
  flex-grow: 1;
  height: 1.75rem;
  display: flex;
  flex-direction: row;
`;
